import type { NestedFilter } from '@@partner:types:graphql'

import React, { useCallback, useEffect, useState } from 'react'

import { useFetchAllShops } from '@@partner:graphql/query/shop/allShops.gql'

import { Button, Form, SelectPicker } from 'rsuite'

import { mergeLeft } from 'merge-left-utils'

import useSearchParams from '@@partner:helpers/hooks/useSearchParams'
import { prepareVehicleFilter, VehiclesFiltersType } from '@@partner:helpers/vehicle'

import './VehiclesFilter.scss'

type VehiclesFilterProps = {
  onFilterChanged: (filters: NestedFilter) => void
}

const defaultFilter: VehiclesFiltersType = {
  license_plate: '',
  status: null,
  
}

// Статусы смен
const VEHICLE_STATUSES = [
  { label: 'Активен', value: true, color: 'green' },
  { label: 'Отключен', value: false, color: 'red' },
  { label: 'Без фильтра', value: null, color: 'blue' }
]

export default function VehiclesFilter ({ onFilterChanged }: VehiclesFilterProps) {
  const { getSearchParams, setSearchParams } = useSearchParams()
  const [ state, setState ] = useState<VehiclesFiltersType>(defaultFilter)

  useEffect(() => {
    const searchParams = getSearchParams()
    const newState: VehiclesFiltersType = mergeLeft(defaultFilter, searchParams)
    setState(newState)
    onFilterChanged(prepareVehicleFilter(newState))
  }, [ ])

  const handleFormSubmit = useCallback(() => {
    setSearchParams(state)
    onFilterChanged(prepareVehicleFilter(state))
  }, [ onFilterChanged, state, setSearchParams ])

  const handleFormChange = (formValue: Partial<VehiclesFiltersType>) => {
    setState((state) => mergeLeft(state, formValue))
  }

  return (
    <Form
      formValue={state}
      className="VehiclesFilter"
      onChange={handleFormChange}
      onSubmit={handleFormSubmit}
    >
      <Form.Group className="VehiclesFilter__Filters">
        <Form.Group>
          <Form.Control name='license_plate' placeholder="Гос. номер" />
        </Form.Group>

        <SelectPicker
          data={VEHICLE_STATUSES}
          value={state.status}
          onChange={(value) => setState(prev => ({ ...prev, status: value || null }))}
          placeholder="Все статусы"
          size="md"
          style={{ width: 200 }}
          cleanable
          searchable={false}
        />

      </Form.Group>

      <div className="VehiclesFilter__Controls">
        <Button
          onClick={handleFormSubmit}
          size="md"
          color="green"
          appearance="primary"
        >
          Поиск
        </Button>
      </div>
    </Form>
  )
}
